import Vue from 'vue';
import Router from 'vue-router';
// 首页
import index from '@/components/index'; // 首页
import goods from '@/components/goods'; // 商品
import integral from '@/components/integral'; // 我的积分
import collection from '@/components/collection'; // 我的收藏
import footprint from '@/components/footprint'; // 我的足迹
import message from '@/components/message'; // 我的消息
import message_details from '@/components/message_details'; // 消息详情
import my_feedback from '@/components/my_feedback'; // 我的反馈
import add_feedback from '@/components/add_feedback'; // 新增反馈
import enterprise_info from '@/components/enterprise_info'; // 企业信息
import shop_cart from '@/components/shop_cart'; // 购物车
import qualifications from '@/components/qualifications'; // 我的资质
import place_order from '@/components/place_order'; // 提交订单
import budgetandsettlement from '@/components/budgetandsettlement'; // 提交订单
import credit_y from '@/components/credit_y'; // 授信余额
import credit_pay from '@/components/credit_pay'; // 创建订单
import reset_password from '@/components/reset_password'; // 重置密码
import order from '@/components/order'; // 我的订单
import my_invoice from '@/components/my_invoice'; // 我的发票
import invoice_details from '@/components/invoice_details'; //发票详情
import pay_to from '@/components/pay_to'; // 付款到
import control_over_invoices from '@/components/control_over_invoices'; // 发票管理
import news from '@/components/news'; // 资讯
import news_details from '@/components/news_details'; // 资讯详情
import user from '@/components/user'; // 个人中心
import user_info from '@/components/user_info'; // 个人信息
import account_security from '@/components/account_security'; // 账户安全
import goods_type from '@/components/goods_type'; // 商品分类
import goods_details from '@/components/goods_details'; // 商品详情
import login from '@/components/login'; // 账号密码登录
import code_login from '@/components/code_login'; // 短信登录
import wangjimima from '@/components/wangjimima'; // 忘记密码
import pay_successful from '@/components/pay_successful'; // 支付成功
import add_pupiao from '@/components/add_pupiao'; // 添加普票
import add_zhuanpiao from '@/components/add_zhuanpiao'; // 添加专票
import add_ticket_info from '@/components/add_ticket_info'; // 添加收票信息
import change_tel from '@/components/change_tel'; // 更换手机
import address_list from '@/components/address_list'; // 收货地址
import login_password from '@/components/login_password'; // 设置登录密码
import refund from '@/components/refund'; // 退款
import refund_details from '@/components/refund_details'; // 退款详情
import dinzhi_order from '@/components/dinzhi_order'; // 定制订单
import ordering_guide from '@/components/ordering_guide'; // 订购指南
import return_policy from '@/components/return_policy'; // 退货说明
import chang_login_password from '@/components/chang_login_password'; // 修改登录密码
import reference_material from '@/components/reference_material'; // 参考资料
import service_support from '@/components/service_support'; // 服务支持
import about_us from '@/components/about_us'; // 关于我们
import billing_record from '@/components/billing_record'; // 开票记录
import add_ticket_collection_method from '@/components/add_ticket_collection_method'; // 添加收票方式
import user_info_edit from '@/components/user_info_edit'; // 编辑资料
import direct_place_order from '@/components/direct_place_order'; // 创建订单
import complaint_details from '@/components/complaint_details'; // 反馈详情
import error from '@/components/404'; // 反馈详情
// import login_m  from '@/components/login_m' // 跳转平台端
// import login_s  from '@/components/login_s' // 跳转店铺端
import customized from '@/components/customized'; // 定制
import purchase from '@/components/purchase'; // 批量采购
import download from '@/components/download'; // 文档下载
import zhifubao from '@/components/zhifubao'; // 批量采购
Vue.use(Router);

export default new Router({
  routes: [
    // { path: '/login_s', name: 'login_s', component: login_s, meta: { title: '店铺登录' } },
    // { path: '/login_m', name: 'login_m', component: login_m, meta: { title: '平台登录' } },
    { path: '/error', name: 'error', component: error, meta: { title: '错误页' } },
    { path: '/complaint_details', name: 'complaint_details', component: complaint_details, meta: { title: '反馈详情' } },
    { path: '/direct_place_order', name: 'direct_place_order', component: direct_place_order, meta: { title: '创建订单' } },
    { path: '/user_info_edit', name: 'user_info_edit', component: user_info_edit, meta: { title: '编辑资料' } },
    { path: '/add_ticket_collection_method', name: 'add_ticket_collection_method', component: add_ticket_collection_method, meta: { title: '添加收票方式' } },
    { path: '/billing_record', name: 'billing_record', component: billing_record, meta: { title: '开票记录' } },
    { path: '/about_us', name: 'about_us', component: about_us, meta: { title: '关于我们' } },
    { path: '/service_support', name: 'service_support', component: service_support, meta: { title: '服务支持' } },
    { path: '/reference_material', name: 'reference_material', component: reference_material, meta: { title: '参考资料' } },
    { path: '/return_policy', name: 'return_policy', component: return_policy, meta: { title: '退货说明' } },
    { path: '/chang_login_password', name: 'chang_login_password', component: chang_login_password, meta: { title: '修改登录密码' } },
    { path: '/refund_details', name: 'refund_details', component: refund_details, meta: { title: '售后详情' } },
    { path: '/ordering_guide', name: 'ordering_guide', component: ordering_guide, meta: { title: '订购指南' } },
    { path: '/dinzhi_order', name: 'dinzhi_order', component: dinzhi_order, meta: { title: '定制订单' } },
    { path: '/refund', name: 'refund', component: refund, meta: { title: '退款' } },
    { path: '/login_password', name: 'login_password', component: login_password, meta: { title: '设置登录密码' } },
    { path: '/', name: 'index', component: index, meta: { title: '首页' } },
    { path: '/goods', name: 'goods', component: goods, meta: { title: '商品' } },
    { path: '/integral', name: 'integral', component: integral, meta: { title: '我的积分' } },
    { path: '/collection', name: 'collection', component: collection, meta: { title: '我的收藏' } },
    { path: '/footprint', name: 'footprint', component: footprint, meta: { title: '我的足迹' } },
    { path: '/message', name: 'message', component: message, meta: { title: '我的消息' } },
    { path: '/message_details', name: 'message_details', component: message_details, meta: { title: '消息详情' } },
    { path: '/my_feedback', name: 'my_feedback', component: my_feedback, meta: { title: '我的反馈' } },
    { path: '/add_feedback', name: 'add_feedback', component: add_feedback, meta: { title: '新增反馈' } },
    { path: '/enterprise_info', name: 'enterprise_info', component: enterprise_info, meta: { title: '企业信息' } },
    { path: '/shop_cart', name: 'shop_cart', component: shop_cart, meta: { title: '购物车' } },
    { path: '/qualifications', name: 'qualifications', component: qualifications, meta: { title: '我的资质' } },
    { path: '/place_order', name: 'place_order', component: place_order, meta: { title: '提交订单' } },
    { path: '/budgetandsettlement', name: 'budgetandsettlement', component: budgetandsettlement, meta: { title: '订单预结算' } },
    { path: '/credit_y', name: 'credit_y', component: credit_y, meta: { title: '授信建档' } },
    { path: '/credit_pay', name: 'credit_pay', component: credit_pay, meta: { title: '创建订单' } },
    { path: '/reset_password', name: 'reset_password', component: reset_password, meta: { title: '重置密码' } },
    { path: '/order', name: 'order', component: order, meta: { title: '我的订单' } },
    { path: '/my_invoice', name: 'my_invoice', component: my_invoice, meta: { title: '我的发票' } },
    { path: '/invoice_details', name: 'invoice_details', component: invoice_details, meta: { title: '发票详情' } },
    { path: '/pay_to', name: 'pay_to', component: pay_to, meta: { title: '付款到' } },
    { path: '/control_over_invoices', name: 'control_over_invoices', component: control_over_invoices, meta: { title: '发票管理' } },
    { path: '/news', name: 'news', component: news, meta: { title: '资讯' } },
    { path: '/news_details', name: 'news_details', component: news_details, meta: { title: '资讯详情' } },
    { path: '/user', name: 'user', component: user, meta: { title: '个人中心' } },
    { path: '/user_info', name: 'user_info', component: user_info, meta: { title: '个人信息' } },
    { path: '/account_security', name: 'account_security', component: account_security, meta: { title: '账户安全' } },
    { path: '/goods_type', name: 'goods_type', component: goods_type, meta: { title: '商品分类' } },
    { path: '/goods_details', name: 'goods_details', component: goods_details, meta: { title: '商品详情' } },
    { path: '/customized', name: 'customized', component: customized, meta: { title: '定制' } },
    { path: '/purchase', name: 'purchase', component: purchase, meta: { title: '批量采购' } },
    { path: '/download', name: 'download', component: download, meta: { title: '文档下载' } },
    { path: '/code_login', name: 'code_login', component: code_login, meta: { title: '短信登录' } },
    { path: '/wangjimima', name: 'wangjimima', component: wangjimima, meta: { title: '忘记密码' } },
    { path: '/pay_successful', name: 'pay_successful', component: pay_successful, meta: { title: '支付成功' } },
    { path: '/add_pupiao', name: 'add_pupiao', component: add_pupiao, meta: { title: '添加普票' } },
    { path: '/add_zhuanpiao', name: 'add_zhuanpiao', component: add_zhuanpiao, meta: { title: '添加专票' } },
    { path: '/add_ticket_info', name: 'add_ticket_info', component: add_ticket_info, meta: { title: '添加收票信息' } },
    {
      path: '/change_tel',
      name: 'change_tel',
      component: change_tel,
      meta: { title: '更换手机' },
      props: true
    },
    { path: '/address_list', name: 'address_list', component: address_list, meta: { title: '收货地址' } },
    { path: '/address_list', name: 'address_list', component: address_list, meta: { title: '收货地址' } },
    { path: '/zhifubao', name: 'zhifubao', component: zhifubao, meta: { title: '支付宝支付' } },
    {
      path: 'login',
      redirect: '/login',
      name: 'login',
      component: () => import('../views/login/Index.vue'),
      meta: { title: '登录' },
      children: [
        {
          path: '/login',
          name: 'SignIn',
          component: () => import('../views/login/SignIn.vue'),
          meta: { title: '账号密码登录' }
        },
        {
          path: '/register/:mobile',
          name: 'register',
          props: true,
          component: () => import('../views/login/register.vue'),
          meta: { title: '账号密码登录' }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js